export const localStorageKey = {
   partnerToken: 'token_partner',
   employerToken: 'token',
   rememberMe: 'rememberMe',
   jobcaseToken: 'token_jobcase',
   jobcaseRefreshToken: 'token_refresh_jobcase',
   arrivalKey: 'arrival_key',
};

export default localStorageKey;
